"use client";

import React from "react";
import BaseTailoringQuestions, { TailoringQuestion } from "../../shared/BaseTailoringQuestions";

interface FCRPTailoringQuestionsProps {
  onBack?: () => void;
}

const tailoringQuestions: TailoringQuestion[] = [
  {
    id: "FCRP-1",
    question: "Does the entity have a defined financial closing and reporting process?",
    type: "radio",
    options: ["Yes", "No"],
  },
  {
    id: "FCRP-2",
    question: "Are there any significant IT systems used in the financial reporting process?",
    type: "radio",
    options: ["Yes", "No"],
  },
];

export default function FCRPTailoringQuestions({ onBack }: FCRPTailoringQuestionsProps) {
  return (
    <BaseTailoringQuestions
      areaName="Financial Closing & Reporting Process"
      title="Financial Closing & Reporting Process - Tailoring Questions"
      description="Customize the audit program for Financial Closing & Reporting Process"
      questions={tailoringQuestions}
      onBack={onBack}
    />
  );
}
